import { render } from "./tab-riwayat-follow-up.vue?vue&type=template&id=6e742b5c&scoped=true&ts=true"
import script from "./tab-riwayat-follow-up.vue?vue&type=script&lang=ts"
export * from "./tab-riwayat-follow-up.vue?vue&type=script&lang=ts"

import "./tab-riwayat-follow-up.vue?vue&type=style&index=0&id=6e742b5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e742b5c"]])

export default __exports__